import PropTypes from 'prop-types'
import TextareaWiz from '../../../../../../../common/inputs/wizard/TextareaWiz.jsx'
import {JsonViewer} from '../../../../../../../common/JsonViewer.jsx'
import {HeaderTitle} from '../../../../../../../common/HeaderTitle.jsx'

export const CelGlowny = (props) => {

    return (
        <div>
            <JsonViewer src={props.wiz?.form || {}} show={false}/>
            <div className={'d-flex flex-column gap-3'}>
                <HeaderTitle noHr size={'fs-3'} title={'Cel główny projektu'}/>
                <HeaderTitle
                    noHr
                    size={'fs-4'}
                    title={'Wprowadź dane dotyczące głównego celu projektu'}
                />

                <div className={'d-flex flex-column gap-2'}>
                    <TextareaWiz wiz={props.wiz} keyName={'cel_glowny'}/>
                    <TextareaWiz wiz={props.wiz} keyName={'wskazniki_realizacji'}/>
                    <TextareaWiz wiz={props.wiz} keyName={'uzasadnienie_celowosci'}/>
                    <TextareaWiz wiz={props.wiz} keyName={'grupa_docelowa'}/>
                </div>
            </div>
        </div>
    )
}

CelGlowny.propTypes = {
    wiz: PropTypes.any,
}
